import { Box, GlobalStyles} from '@mui/system'
import React, { useLayoutEffect } from 'react'
import { Cookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import AppPopup from './components/AppPopup'
import { AppSpin } from './components/AppSpin'
import LoginForm from './components/Auth/Auth'
import { useDefaultComponentTools } from './hooks/useDefaultComponentTools'
import TradingPage from './pages/TradingPage/TradingPage'
import { getTradingHoursData } from './store/redusers/assets/actions'
import { selectSelectedAsset } from './store/redusers/assets/selectors'
import {
	setShowLoginPopup,
	setToken
} from './store/redusers/auth/actions'
import {
	selectAccessToken,
	selectIsShowLogin
} from './store/redusers/auth/selectors'
import {
	getSocket,
	initConnectWS,
	initWS
} from './store/redusers/sockets/actions'
import {
	getJsonAction,
	getMsgsAction,
	getUser,
	logOut
} from './store/redusers/user/actions'
import { getSimpleLang } from './helpers'

function App() {
	const {dispatch, loading, isMounted, setLoading, t} = useDefaultComponentTools(true)
	const {i18n} = useTranslation()
	const cookies = new Cookies()
	const accessToken = useSelector(selectAccessToken)
	const cookieAccessToken = cookies.get('oauth_access_token')
	const isShowLogin = useSelector(selectIsShowLogin)
	const selectedAsset = useSelector(selectSelectedAsset)
	localStorage.setItem('trading-selected-asset', JSON.stringify(selectedAsset))
	localStorage.removeItem('trading-risk_data')

	const initCheckToken = () => {
		let initSetInterval = setInterval(() => {
			onCheckToken()
		}, 300)
		let initUserInterval = setInterval(async () => {
			getUserData(true)
		}, 30000)
		const onCheckToken = () => {
			if (!cookies.get('oauth_access_token')) {
				clearInterval(initSetInterval)
				clearInterval(initUserInterval)
				const socket = getSocket()
				if (socket?.id) {
					socket.emit('disconnectCustom', socket.id)
				}
				dispatch(logOut())
				dispatch(setShowLoginPopup(true))
			}
		}
	}
	const getUserData = async (loop) => {
		try {
			if (!loop) {
				let pricer = await dispatch(getJsonAction(cookieAccessToken || accessToken, getSimpleLang(i18n.language)))
				const socket = getSocket()
				if (pricer?.link && pricer?.port && !socket?.id) {
					const ws = await initWS(pricer.link, pricer.port)
					if (ws) {
						ws.on('connect', () => dispatch(initConnectWS(true)))
					}
				}
				await dispatch(getTradingHoursData())
			}
			if (cookieAccessToken || accessToken) {
				let user = await dispatch(getUser(cookieAccessToken || accessToken))
				await dispatch(getMsgsAction(cookieAccessToken || accessToken))
				if(user && !loop && !accessToken) {
					dispatch(setToken(cookieAccessToken))
				}
				await localStorage.removeItem('newUserData')
				localStorage.setItem('newUserData', JSON.stringify(user))
			}
		} catch (e) {
			// eslint-disable-next-line
			console.log(e.message)
		} finally {
			isMounted() && setLoading(false)
		}
	}
	useLayoutEffect(() => {
		if (!(i18n.languages.includes(i18n.language))) i18n.changeLanguage('en')
		document.body.dir = i18n.dir()
		getUserData(false)
		if(!accessToken) return
		initCheckToken()
	}, [accessToken])


	return (
		<Box className='App' sx={{height: '100vh', width: '100%'}}>
			<GlobalStyles
				styles={(theme) => ({
					'*,*::before,*::after': {
						boxSizing: 'border-box',
						margin: 0,
						padding: 0
					},
					'.MuiDialog-root': {
						zIndex: '99 !important'
					},
					'.MuiList-root': {background: theme.palette.second, opacity: 1},
					'::-webkit-scrollbar': {
						width: '12px'
					},
					'::-webkit-scrollbar-thumb': {
						'&:active': {
							background: theme.palette.background
						},
						background: theme.palette.fourth,
						border: `4px solid ${theme.palette.second}`,
						borderRadius: '32px'
					},
					'::-webkit-scrollbar-track': {
						background: theme.palette.second,
						borderRadius: '0 4px 4px 0'
					},
					body: {
						backgroundColor: theme.palette.background,
						color: theme.palette.text.primary,
						margin:0,
						overflowX: 'hidden'
					},
					fieldset: {
						border: 0,
						borderWidth: '0 !important',
						outline: 'none'
					}
				})}
			/>
			{loading ? <AppSpin /> : <TradingPage />}
			{!isShowLogin ?
				null :
				<AppPopup
					setOpenedComponent={() => dispatch(setShowLoginPopup(false))}
					title={t('Log In')}
				>
					<LoginForm />
				</AppPopup>
			}
		</Box>
	)
}

export default App
